import { FC, useEffect } from 'react';
import OutgoingDocumentAddEditBaseView from './base';
import store from "./store"
import { observer } from "mobx-react"
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomButton from 'components/Button';

type PopupFormProps = {
  openPanel: boolean;
  id: number;
  onBtnCancelClick: () => void;
  onSaveClick: (id: number) => void;
}

const OutgoingDocumentPopupForm: FC<PopupFormProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    if (props.openPanel) {
      store.doLoad(props.id)
    } else {
      store.clearStore()
    }
  }, [props.openPanel])

  return (
    <Dialog open={props.openPanel} onClose={props.onBtnCancelClick} maxWidth="md" fullWidth>
      <DialogTitle>{translate('label:outgoingDocumentAddEditView.entityTitle')}</DialogTitle>
      <DialogContent>
        <OutgoingDocumentAddEditBaseView
          isPopup={true}
        >
        </OutgoingDocumentAddEditBaseView>
      </DialogContent>
      <DialogActions>
        <CustomButton
          variant="contained"
          id="id_outgoingDocumentSaveButton"
          name={'outgoingDocumentAddEditView.save'}
          onClick={() => {
            store.onSaveClick((id: number) => props.onSaveClick(id))
          }}
        >
          {translate("common:save")}
        </CustomButton>
        <CustomButton
          variant="contained"
          id="id_outgoingDocumentCancelButton"
          name={'outgoingDocumentAddEditView.cancel'}
          onClick={() => props.onBtnCancelClick()}
        >
          {translate("common:cancel")}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
})

export default OutgoingDocumentPopupForm